<script setup>
import { computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useUISettings } from 'dashboard/composables/useUISettings';
import ConversationBox from 'dashboard/components/widgets/conversation/ConversationBox.vue';
import ConversationSidebar from 'dashboard/components/widgets/conversation/ConversationSidebar.vue';
import SidepanelSwitch from 'dashboard/components-next/Conversation/SidepanelSwitch.vue';

const props = defineProps({
  conversationId: { type: Number, required: true },
});

const store = useStore();
const getConversationById = useMapGetter('getConversationById');
const currentChat = useMapGetter('getSelectedChat');
const { uiSettings } = useUISettings();

// Painel de Contato/Copiloto igual ao da tela de Conversas
const shouldShowSidebar = computed(
  () => !!currentChat.value.id && !!uiSettings.value.is_contact_sidebar_open
);

// Mesmo fluxo do ConversationView: garante a conversa na store e a marca
// como ativa pro ConversationBox renderizar.
const openConversation = async () => {
  if (!getConversationById.value(props.conversationId)) {
    await store.dispatch('getConversation', props.conversationId);
  }
  const data = getConversationById.value(props.conversationId);
  if (data) store.dispatch('setActiveChat', { data });
};

watch(() => props.conversationId, openConversation);
onMounted(() => {
  store.dispatch('agents/get');
  store.dispatch('portals/index');
  openConversation();
});
onBeforeUnmount(() => store.dispatch('clearSelectedState'));
</script>

<template>
  <div class="flex w-full h-full min-w-0">
    <ConversationBox :inbox-id="0" :is-on-expanded-layout="false">
      <SidepanelSwitch v-if="currentChat.id" />
    </ConversationBox>
    <ConversationSidebar v-if="shouldShowSidebar" :current-chat="currentChat" />
  </div>
</template>
